import React from "react";
import "./Group286.css";

function Group286(props) {
  const { src, className } = props;

  return (
    <div className={`group-286-1 border-1px-black ${className || ""}`}>
      <img className="more-than-3" src={src} />
    </div>
  );
}

export default Group286;
